import React, { ReactElement } from 'react';
import './Modal.scss';

interface Props {
  children: React.ReactNode;
  visible: boolean;
  onClose: () => void;
  title?: string;
}

export default function Modal(props: Props): ReactElement {
  return props.visible ? (
    <div>
      <div id="openModal-about" className="modalDialog">
        <div>
          <button className="close" onClick={() => props.onClose()}>
            X
          </button>
          <h4>{props.title}</h4>
          <hr />
          {props.children}
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
}
